import { Reducer } from 'redux';

import * as ActionTypes from '../actions/types';
import * as Actions from '../actions';
import * as Model from '../models';

export const projects: Reducer<Model.ProjectItem[], Model.ReduxAction<object>> = (state = [], action: Model.ReduxAction<object>) => {
  if (!action || !action.type) {
    return state;
  }
  let srcProject: Model.ProjectItem;
  let project: Model.ProjectItem;
  let oligos: Model.OligoItem[];
  let projectIdx: number;
  const { type } = action;
  switch (type) {
    case ActionTypes.ADD_PROJECT:
      project = (action as Model.ReduxAction<Actions.ProjectAddActionPayload>).payload;
      return [...state, project];
    case ActionTypes.UPDATE_PROJECT:
      project = (action as Model.ReduxAction<Actions.ProjectUpdateActionPayload>).payload;
      state = [...state];
      state.splice(project.index, 1, project);
      return state;
    case ActionTypes.DELETE_PROJECT:
      const { payload: deleteProjectPayload } = action as Model.ReduxAction<Actions.ProjectDeleteActionPayload>;
      projectIdx = deleteProjectPayload.index;
      state = [...state];
      state.splice(projectIdx, 1);
      state = state.map((projectItem: Model.ProjectItem) => {
        const newIndex: number = projectItem.index - 1;
        return projectItem.index > projectIdx ? {
          ...projectItem,
          ...{
            index: newIndex,
            name: projectItem.name.replace(/\d+/g, (newIndex + 1).toString()),
          },
        } : projectItem;
      });
      return state;
    case ActionTypes.ADD_OLIGO:
      const { payload: addOligoPayload } = action as Model.ReduxAction<Actions.OligoAddActionPayload>;
      const { oligos: oligosToAdd } = addOligoPayload;
      projectIdx = addOligoPayload.projectIdx;
      state = [...state];
      srcProject = state[projectIdx];
      oligos = srcProject.oligos;
      oligosToAdd.sort((oligo1: Model.OligoItem, oligo2: Model.OligoItem) => oligo1.index - oligo2.index);
      state[projectIdx] = { ...srcProject, ...{oligos: [...oligos, ...oligosToAdd]} };
      return state;
    case ActionTypes.UPDATE_OLIGO:
      const { payload: updateOligoPayload } = action as Model.ReduxAction<Actions.OligoUpdateActionPayload>;
      const { oligo } = updateOligoPayload;
      projectIdx = updateOligoPayload.projectIdx;
      state = [...state];
      srcProject = state[projectIdx];
      oligos = [...srcProject.oligos];
      oligos.splice(oligo.index, 1, oligo);
      state[projectIdx] = { ...srcProject, ...{ oligos } };
      return state;
    case ActionTypes.DELETE_OLIGO:
      const { payload: deleteOligoPayload } = action as Model.ReduxAction<Actions.OligoDeleteActionPayload>;
      const { index: oligoIdx } = deleteOligoPayload;
      projectIdx = deleteOligoPayload.projectIdx;
      state = [...state];
      srcProject = state[projectIdx];
      oligos = [...srcProject.oligos];
      oligos.splice(oligoIdx, 1);
      oligos = oligos.map((oligoItem: Model.OligoItem) => {
        const newIndex: number = oligoItem.index - 1;
        return oligoItem.index > oligoIdx ? {
          ...oligoItem,
          ...{ index: newIndex },
        } : oligoItem;
      });
      state[projectIdx] = { ...srcProject, ...{ oligos } };
      return state;
    case ActionTypes.LOAD_PROJECTS:
      state = (action as Model.ReduxAction<Actions.ProjectsLoadActionPayload>).payload;
      return state;
    default:
      break;
  }
  return state;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/reducers/project-reducer.ts